import {
  alpha,
  Stack,
  styled,
  Tab,
  Table,
  Tabs,
} from '@ltvco/refresh-lib/theme';

export const UsageTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 48,
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: 3,
  },
}));

export const UsageTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightMedium ?? 500,
  fontSize: '0.9375rem',
  minHeight: 48,
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  color: theme.palette.text.secondary,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
  },
}));

export const MonthlyUsageTable = styled(Table)(({ theme }) => ({
  tableLayout: 'fixed',
  width: '100%',
  '& .MuiTableCell-root': {
    width: '50%',
  },
  '& .MuiTableCell-root:not(:last-of-type)': {
    borderRight: '1px solid',
    borderRightColor: theme.palette.divider,
  },
}));

export const TransactionListItem = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'baseline',
  gap: theme.spacing(1, 2),
  py: 0.5,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
